module.exports = __webpack_public_path__ + "static/media/FASNYLogoProcess5.85fac6b2.jpg";